import { useRouter } from 'next/navigation'
import { useState, useEffect } from 'react'

import exploreEvents from '@/utils/gaEvents/exploreEvents'

import Icons from '@/shared/components/icon/Icons'
import { Text } from '@/shared/components/typography'
import useHash from '@/shared/hooks/useHash'

import { SHEET_STATE_TYPE } from '@/enums/detail'
import { CATE_CATEGORY } from '@/enums/gtagEvents'

interface ParkinglotDetailHeaderViewProps {
  parkinglotName: string
  parkinglotSeq: number | null
  isPartner?: boolean
}

const ParkinglotDetailHeaderView = ({ parkinglotName, parkinglotSeq, isPartner }: ParkinglotDetailHeaderViewProps) => {
  const [scrollHeight, setScrollHeight] = useState(0)
  const router = useRouter()
  const { updateHash } = useHash()

  useEffect(() => {
    const sheet = document.getElementById('modu-scroll') as HTMLDivElement

    const handleScroll = () => {
      setScrollHeight(sheet.scrollTop)
    }

    sheet.addEventListener('scroll', handleScroll)

    return () => {
      sheet.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const onClickBackIcon = () => {
    if (parkinglotSeq == null) return
    const pathname = window.location.pathname
    const searchParams = window.location.search
    const hash = updateHash({ sheet: SHEET_STATE_TYPE.HIDDEN })
    router.push(`${pathname}${searchParams}${hash}`)
    if (isPartner === undefined) {
      exploreEvents.shared.onClickBackButton(parkinglotSeq)
    } else {
      exploreEvents.partner.onClickBackButton(isPartner ? CATE_CATEGORY.PARTNER : CATE_CATEGORY.NORMAL, parkinglotSeq)
    }
  }

  return (
    <nav className="sticky left-0 top-0 z-20 w-full max-w-[768px] flex-col">
      <div className={`mx-auto flex h-[56px] w-full items-center ${scrollHeight >= 114 ? 'bg-010' : 'bg-transparent'}`}>
        {scrollHeight >= 114 ? (
          <>
            <div className={`ml-[16px] mr-[8px] h-[24px] w-[24px] cursor-pointer`} onClick={onClickBackIcon}>
              <Icons.BackIcon stroke="currentColor" color="#263238" />
            </div>
            <Text level="text3" weight="regular" color="text090">
              {parkinglotName}
            </Text>
          </>
        ) : (
          <button
            className={`ml-[16px] flex h-[40px] w-[40px] items-center justify-center rounded-full bg-010 shadow-120`}
            type="button"
            onClick={onClickBackIcon}
          >
            <Icons.BackIcon stroke="currentColor" color="#263238" />
          </button>
        )}
      </div>
    </nav>
  )
}

export default ParkinglotDetailHeaderView
